import { Observable } from 'rxjs';
import { System } from './../../shared-components/System';
import {Injectable} from '@angular/core';
import {StudentService} from '../../shared-components/student/student.service';
import {HttpClient} from '@angular/common/http';
import { Assessment, TestMasterLayoutVersion, AssessmentField } from './assessment.model';
import {UserService} from '../../shared-components/user/user.service';
import { Router } from '@angular/router';
import { YearService } from '../../shared-components/year/year.service';

@Injectable()
export class AssessmentService {

	// Properties

	// Class Functions
	constructor (
		private studentService: StudentService,
		private userService: UserService,
        private yearService: YearService,
        private router: Router,
		private http: HttpClient
	) {}

	// Event Functions

	// Methods
	getStudentAssessmentTabs(yearId: number): Observable<Assessment[]> {
		const queryString = '?studentId=' + this.studentService.selectedStudent.Id +
			'&loginId=' + this.userService.currentUser.Id +
			'&SiteYearId=' + yearId;
		return this.http.get<Assessment[]>(System.apiURL.Student + 'GetStudentAssessmentsTab' + queryString);
	}

	getStudentAssessments(tabs: Assessment[]): Observable<Assessment[]> {
		// PRE: there is a selected student in the student service,
		// 		a siteYearId in the year service,
		// 		and a loginId in the login service
		// POST: gets the students assessments for this particular year and login
        let siteYearId = this.router.url.indexOf('registrationEnroll') == -1 ? this.studentService.studentEnrollment.SiteYearId : this.yearService.defaultYear.SiteYearId;
		const queryString = '?studentId=' + this.studentService.selectedStudent.Id +
			'&SiteYearId=' + siteYearId +
			'&loginId=' + this.userService.currentUser.Id;
		return this.http.post<Assessment[]>(System.apiURL.Student + 'GetStudentAssessments' + queryString, tabs);
	}

	getTestMasterLayoutVersion(): Observable<TestMasterLayoutVersion[]> {
		return this.http.get<TestMasterLayoutVersion[]>(System.apiURL.Student + 'GetTestMasterLayoutVersion');
	}

	getAssessmentFieldsReadByInstIdOrVersionId(instanceId: number, testMasterVersionId: number): Observable<AssessmentField[]> {
		const queryString = '?instanceId=' + instanceId +
			'&testMasterVersionId=' + testMasterVersionId;
		return this.http.get<AssessmentField[]>(System.apiURL.Student + 'GetAssessmentFieldsReadByInstIdOrVersionId' + queryString);
	}

	saveAssessment(studentId: number, instanceId: number, versionId: number, assessmentDate: string, printOnTranscript: boolean, isImportedData: boolean, assessmentFields: AssessmentField[]): Observable<number> {
		const queryString = '?studentId=' + studentId +
			'&instanceId=' + instanceId +
			'&versionId=' + versionId +
			'&assessmentDate=' + assessmentDate +
			'&printOnTranscript=' + printOnTranscript +
			'&isImportedData=' + isImportedData;
		return this.http.post<number>(System.apiURL.Student + 'SaveAssessment' + queryString, assessmentFields);
	}

	deleteAssessmentById(instanceId: number): Observable<boolean> {
        return this.http.get<boolean>(System.apiURL.Student + `DeleteAssessmentById?instanceId=${instanceId}`);
    }
}
